import React, {use, useRef} from "react";
import Map from "./Map";

const MapContainer = ({
  selectedPortofLoading,
  selectedPortofDischarge,
  setSelectedPortofLoading,
  setSelectedPortofDischarge,
  handleSelectPort,
}) => {
  const loadMap = true; // Placeholder to indicate map loading status

  if (!loadMap) {
    return (
      <div className="map-container">
        <div className="map-placeholder">
          <h3>MapTiler Karte wird hier geladen</h3>
          <p>75% der Bildschirmhöhe</p>
        </div>
      </div>
    );
  } else {
    return (
      <div className="map-container">
        <Map
          selectedPortofLoading={selectedPortofLoading}
          selectedPortofDischarge={selectedPortofDischarge}
          setSelectedPortofLoading={setSelectedPortofLoading}
          setSelectedPortofDischarge={setSelectedPortofDischarge}
          handleSelectPort={handleSelectPort}
        />
      </div>
    );
  }
};

export default MapContainer;
